import { render } from "./PostToAccountSupplier.vue?vue&type=template&id=6af38122&scoped=true"
import script from "./PostToAccountSupplier.vue?vue&type=script&lang=js"
export * from "./PostToAccountSupplier.vue?vue&type=script&lang=js"

import "./PostToAccountSupplier.vue?vue&type=style&index=0&id=6af38122&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af38122"]])

export default __exports__